// src/services/adminBoutique.js
// Domaine Boutique — façade Worker Admin → Worker Boutique uniquement.

import { apiFetch } from './adminHttp';

/* ---------- Produits ---------- */

/** GET /admin/boutique/products — BOUTIQUE_VOIR */
export async function getProducts() {
  return apiFetch('/admin/boutique/products', { method: 'GET' });
}

/**
 * POST /admin/boutique/products — BOUTIQUE_PRODUITS_MODIFIER
 * Body minimal : { title, category, priceDsi }
 */
export async function createProduct(payload) {
  return apiFetch('/admin/boutique/products', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** PATCH /admin/boutique/products/:id — BOUTIQUE_PRODUITS_MODIFIER */
export async function updateProduct(id, payload) {
  return apiFetch(`/admin/boutique/products/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

/** DELETE /admin/boutique/products/:id — BOUTIQUE_PRODUITS_MODIFIER */
export async function deleteProduct(id) {
  return apiFetch(`/admin/boutique/products/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}

/* ---------- Promotions ---------- */

/** GET /admin/boutique/promos — BOUTIQUE_VOIR */
export async function getPromos() {
  return apiFetch('/admin/boutique/promos', { method: 'GET' });
}

/**
 * POST /admin/boutique/promos — BOUTIQUE_PROMOS_MODIFIER
 * Body minimal : { code, type: "percent"|"fixed" }
 * Optionnels : value, maxUses, maxUsesPerMember, active, startsAt, expiresAt
 */
export async function createPromo(payload) {
  return apiFetch('/admin/boutique/promos', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/**
 * PATCH /admin/boutique/promos/:code — BOUTIQUE_PROMOS_MODIFIER
 * Identifiant = code
 */
export async function updatePromo(code, payload) {
  return apiFetch(`/admin/boutique/promos/${encodeURIComponent(code)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

/* ---------- Statistiques ---------- */

/**
 * GET /admin/boutique/stats — BOUTIQUE_VOIR
 * Structure normative (autorité Worker Boutique) :
 * products { total, draft, published, archived }
 * orders { total, validating, pendingPayment, processing, paid, failed, paymentUnknown }
 * sales { paidOrders, totalDsi }
 * entitlements { total, unresolved }
 * promos { total, currentlyUsable, totalRedemptions, totalDiscountDsi }
 */
export async function getBoutiqueStats() {
  return apiFetch('/admin/boutique/stats', { method: 'GET' });
}
